
/* eslint-disable eqeqeq, no-unneeded-ternary, key-spacing, comma-spacing */
import PDate from './../components/shared/PDate'
import PDateTime from './../components/shared/PDateTime'
import PPeriodDialog from './../components/shared/PPeriodDialog'
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
momentDurationFormatSetup(moment)
export default {
  components: {PDate, PDateTime, PPeriodDialog},
  data: () => ({
    editedItem: {id:'',properties:{task_template_id:[],exibitionType:null,id_text:'',team_id:[],user_id:[],category:[],client:[],status:[],created_at_period:'',end_period:'',created_by:[],sortBy:'created_at',descending:true,showTaskLevel:1,showFinalized:true,room:''}},
    defaultEditedItem:{id:'',properties:{task_template_id:[],exibitionType:null,id_text:'',team_id:[],user_id:[],category:[],client:[],status:[],created_at_period:'',end_period:'',created_by:[],sortBy:'created_at',descending:true,showTaskLevel:1,showFinalized:true,room:''}},
    dialogFilter: false,
    allItemsTasktemplate: {},
    periodDialog: false,
    dateDialog: false,
    taskFilters: [],
    allLess: false,
    dateFilterItems: [{value: 'Diária', text: 'Diária'}, {value: 'Semanal', text: 'Semanal'}, {value: 'Mensal', text: 'Mensal'}, {value: 'Período', text: 'Período'}]
  }),
  methods: {
    afterOpenTaskFilter () { },
    save () {
      this.$store.commit('loader/change_dialog', true)
      // Salva os dados do board no PTaskBoard
      this.$emit('save', JSON.parse(JSON.stringify(this.editedItem)))
      this.close()
    },
    openTaskFilter (filterValues) {
      this.editedItem = JSON.parse(JSON.stringify(filterValues))
      this.$store.commit('loader/change_dialog', true)
      // passa o board_id para buscar os itens dos campos de acordo com os registros selecionados na area de trabalho
      this.$store.dispatch('selectedBoard/getTaskFilters', {board_id: this.editedItem['task_board_id']}).then((response) => {
        Object.assign(this.taskFilters, response)
        this.allItemsTasktemplate = response['taskTemplates']
        // usa o change team para filtrar as tarefas modelo da equipe
        this.changeTeam(this.editedItem['properties'].team_id)
        this.$emit('openTaskFilter')
        this.dialogFilter = true
        this.afterOpenTaskFilter()
        // verifica se os valores estão na lista
        this.checkProperties()
        this.$store.commit('loader/change_dialog', false)
      }, err => {
        console.log(err)
        this.$store.commit('snackbar/change_values', {
          text: `Ocorreu um erro ao carregar os registros, reporte o erro!`,
          color: 'error',
          dialog: true
        })
        this.$store.commit('loader/change_dialog', false)
      })
    },
    onUserChange (val) {
      if (val.includes('allLess', 0)) {
        this.editedItem['properties'].user_id = ['allLess']
        this.allLess = true
      } else if (val.length === 0) {
        this.allLess = false
      }
    },
    // verifica se alguma propriedade está selecionada porem não está na lista, significando que ela foi deletada
    checkProperties () {
      // Percorre todas as propriedades e verifica se os itens são arrays para poder ver se o item selecionado existe na lista de registros, caso não exista adiciona um item como deletado
      for (var [key, prop] of Object.entries(this.editedItem['properties'])) {
        if (Array.isArray(prop) && prop.length > 0) {
          switch (key) {
            case 'status':
              prop.forEach((val) => {
                // caso não tenha o registro adiciona um de excluido
                if (!this.taskFilters['taskStatus'].some((v) => v.value == val)) {
                  this.taskFilters['taskStatus'].unshift({value: val, id_text: 'Registro excluído'})
                }
              })
              break
            case 'task_template_id':
              // Caso não seja um quadro vinculado com uma tarefa modelo, ai check as propriedades
              // verifica se é array pois quando é array é dos filtros e quando é integer é que a tarefa modelo está vinculada com o quadro
              if (Array.isArray(prop)) {
                prop.forEach((val) => {
                  // caso não tenha o registro adiciona um de excluido
                  if (!this.taskFilters['taskTemplates'].some((v) => v.id == val)) {
                    this.taskFilters['taskTemplates'].unshift({id: val, id_text: 'Registro excluído'})
                  }
                })
              } else if (prop > 0) {
                // caso não tenha o registro adiciona um de excluido
                if (!this.taskFilters['taskTemplates'].some((v) => v.id == prop)) {
                  this.taskFilters['taskTemplates'].unshift({id: prop, id_text: 'Registro excluído'})
                }
              }
              break
            case 'category':
              prop.forEach((val) => {
                // caso não tenha o registro adiciona um de excluido
                if (!this.taskFilters['taskCategories'].some((v) => v.value == val)) {
                  this.taskFilters['taskCategories'].unshift({value: val, id_text: 'Registro excluído'})
                }
              })
              break
            case 'team_id':
              // verifica se é array pois quando é array é dos filtros e quando é integer é que o quadro está comparitlhado com a equipe
              if (Array.isArray(prop)) {
                prop.forEach((val) => {
                  // caso não tenha o registro adiciona um de excluido
                  if (!this.taskFilters['taskTeams'].some((v) => v.id == val)) {
                    this.taskFilters['taskTeams'].unshift({id: val, id_text: 'Registro excluído'})
                  }
                })
              } else if (prop > 0) {
                // caso não tenha o registro adiciona um de excluido
                if (!this.taskFilters['taskTeams'].some((v) => v.id == prop)) {
                  this.taskFilters['taskTeams'].unshift({id: prop, id_text: 'Registro excluído'})
                }
              }
              break
            case 'user_id':
              prop.forEach((val) => {
                // caso não tenha o registro adiciona um de excluido
                if (!this.taskFilters['taskUsers'].some((v) => v.id == val)) {
                  this.taskFilters['taskUsers'].unshift({id: val, id_text: 'Registro excluído'})
                }
              })
              break
            case 'client':
              prop.forEach((val) => {
                // caso não tenha o registro adiciona um de excluido
                if (!this.taskFilters['taskClients'].some((v) => v.value == val)) {
                  this.taskFilters['taskClients'].unshift({value: val, id_text: 'Registro excluído'})
                }
              })
              break
            case 'created_by':
              prop.forEach((val) => {
                // caso não tenha o registro adiciona um de excluido
                if (!this.taskFilters['createdByUser'].some((v) => v.id == val)) {
                  this.taskFilters['createdByUser'].unshift({id: val, id_text: 'Registro excluído'})
                }
              })
              break
          }
        }
      }
    },
    close () {
      this.dialogFilter = false
      this.editedItem = JSON.parse(JSON.stringify(this.defaultEditedItem))
      this.$emit('close')
    },
    changePeriodType (val, field) {
      if (val === 'Período') {
        field == 'end' ? this.periodDialog = true : this.dateDialog = true
      } else {
        this.dateFilterItems[3].text = 'Período'
        delete this.editedItem['properties'][field + '_begin']
        delete this.editedItem['properties'][field + '_end']
      }
      this.editedItem['properties'][field + '_period'] = val ? val : null
    },
    periodChangeProcess (val, field) {
      this.editedItem['properties'][field + '_begin'] = val.begin
      this.editedItem['properties'][field + '_end'] = val.end
    },
    switchFinalized () {
      this.$http.get('api/has_status_finalized').then(res => {
        // caso tenha status finalizado no filtro, faz a troca normal
        if (res.body['has_finalized_status'] == false) {
          this.$store.commit('snackbar/change_values', {
            text: `Essa ${this.translate('table.task_board.title')[0]} não possui status de conclusão.`,
            color: 'warning',
            dialog: true
          })
          this.editedItem['properties']['showFinalized'] = false
          // this.dialogNotStatusFinalized = true
        }
      }, err => {
        this.editedItem['properties']['showFinalized'] = false
        console.log(err)
        this.$store.commit('snackbar/change_values', {
          text: `Ocorreu um erro ao listar as concluidas. Favor reportar o erro.`,
          color: 'error',
          dialog: true
        })
      })
    },
    // Quando muda a equipe deve filtras as tarefas modelo da equipe
    changeTeam (val) {
      // verifica se tem valor e se é array caso seja, busca apenas os modelos das equipes selecionadas, ou modelos sem equipes
      if (Array.isArray(val) && val.length > 0) {
        this.taskFilters['taskTemplates'] = this.allItemsTasktemplate.filter((item) => { return item.team_id === null || val.some((id) => { return id === item.team_id }) })
        // Caso não seja um array e tenha algum valor significa que está compartilhado com as equipes, nesse caso filtra os modelos de acordo com a equipe selecionada ou que não tenha equipe
      } else if (!Array.isArray(val) && val > 0) {
        this.taskFilters['taskTemplates'] = this.allItemsTasktemplate.filter((item) => { return item.team_id === null || item.team_id === val })
      // Caso não tenha valor, busca todas as tarefas modelo
      } else {
        this.taskFilters['taskTemplates'] = this.allItemsTasktemplate
      }
      // verifica se tem o link_template, pois ele so existe na area de trabalho
      if (this.editedItem.hasOwnProperty('link_template')) {
        // coloca setTimeout para dar tempo de preencher o this.taskFilters['taskTemplates']
        setTimeout(() => {
          // se estiver vinculado a uma tarefa modelo, verifica se o campo continuara preenchido
          if (this.editedItem['link_template']) {
            // caso não encontre a tarefa modelo no resultado final, zera os valores
            if (this.editedItem['tasktemplate_id'] && !this.taskFilters['taskTemplates'].some((item) => { return item['id'] === this.editedItem['tasktemplate_id'] })) {
              // Limpa a tarefa modelo
              this.editedItem['tasktemplate_id'] = ''
              this.editedItem['properties']['task_template_id'] = ''
            }
          } else {
            // caso seja array e tenha sido selecionado alguma equipe, então deixa apenas as tarefas modelos daquela equipe
            if (Array.isArray(this.editedItem['properties']['task_template_id']) && this.editedItem['properties']['task_template_id'].length > 0) {
              // verifica se no filtro de equipe não é array e é maior que 0 pois se sim, significa que está com equipe compartilhada e deve filtrar a tarefa modelo de acordo com this.taskFilters['taskTemplates'] que já possui apenas os modelos daquela equipe
              if (!Array.isArray(this.editedItem['properties']['team_id']) && this.editedItem['properties']['team_id'] > 0) {
                this.editedItem['properties']['task_template_id'] = this.editedItem['properties']['task_template_id'].filter((templateId) => { return this.taskFilters['taskTemplates'].some((item) => { return item['id'] == templateId }) })
              }
              // se não for array significa que antes era vinculada com uma tarefa modelo, e agora não está mais e apenas zera a tarefa modelo
            } else {
              this.editedItem['properties']['task_template_id'] = ''
            }
          }
          // Já preenche o filtro do team_id com o valor da equipe compartilhada
        }, 300)
      }
      this.editedItem['properties']['team_id'] = val
    },
    disabledField (item) {
      let result = false
      if ((Array.isArray(item) && item.length > 0) || item > 0) {
        result = true
      }
      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/filterTask.js